// extracted by mini-css-extract-plugin
export default {"title":"AdvancePaymentDetails_title__gIfdR","summary":"AdvancePaymentDetails_summary__y5pSa","edit":"AdvancePaymentDetails_edit__xmtL3"};